import React from "react"
import PropTypes from "prop-types"
import { Icon, Popup } from "semantic-ui-react"

const Info = (props) => {
  const { text } = props
  if (!text) {
    return null
  }

  return (
    <Popup
      trigger={
        <Icon
          color="green"
          className="info-icon"
          link
          circular
          inverted
          name="info"
        />
      }
      content={text}
      basic
      wide
    />
  )
}

export default Info
